import { useState } from 'react';
import { Find, FindStateType, ModalStateType } from '@components/loginModal';
import Login from './login';

import classnames from 'classnames/bind';
import styles from './jobflexLoginModal.module.scss';

const cx = classnames.bind(styles);

const JobflexLoginModal = () => {
  const [modalState, setModalState] = useState<ModalStateType>('LOGIN');
  const [findState, setFindState] = useState<FindStateType>('ID');

  return (
    <div className={cx('container')}>
      <div className={cx('modalWrap')}>
        {modalState === 'LOGIN' && <Login setFindState={setFindState} setModalState={setModalState} />}
        {modalState === 'FIND' && (
          <Find findState={findState} setFindState={setFindState} setModalState={setModalState} />
        )}
      </div>
    </div>
  );
};

export default JobflexLoginModal;
